import React from 'react';
import HeaderText from '../../Common/HeaderText';
import PaymentsListHeader from '../PaymentsListHeader';
import PaymentsList from './PaymentsList';

const PaymentsHistory = () => {
  return (
    <div className='flex flex-col w-full items-start'>
      <HeaderText label={'Payments history'} />
      <PaymentsListHeader type='history' />
      <PaymentsList />
    </div>
  );
};

export default PaymentsHistory;
